import { getBorderRadius } from '$lib/global/helper/border-radius';
import { getShadow } from '$lib/global/helper/shadow';

import type { BrandBorderRadius, BrandShadow, Theme } from '$lib/types/Theme';

type InputShadowComponent = 'textInput' | 'textareaInput' | 'fileInput' | 'checkboxInput';

export interface ResolvedInputStyling {
    borderRadiusClass: string;
    shadowClass: string | undefined;
    borderColor: string | undefined;
    backgroundColor: string | undefined;
    textColor: string | undefined;
    mutedTextColor: string | undefined;
}

interface Params {
    theme: Theme | undefined;
    shadowComponent: InputShadowComponent;
}

export const resolveInputStyling = ({ theme, shadowComponent }: Params): ResolvedInputStyling => {
    const isThemeV2 = !!theme?.surface;

    const borderRadiusClass = getBorderRadius(
        'fieldsWrapper',
        theme?.borderRadius as BrandBorderRadius | undefined,
    );

    const shadowClass =
        isThemeV2 && theme?.shadow
            ? getShadow(shadowComponent, theme.shadow as BrandShadow)
            : undefined;

    return {
        borderRadiusClass,
        shadowClass,
        borderColor: isThemeV2 ? theme?.border : undefined,
        backgroundColor: isThemeV2 ? theme?.surface : undefined,
        textColor: isThemeV2 ? theme?.fontColor : undefined,
        mutedTextColor: isThemeV2 ? theme?.mutedText : undefined,
    };
};
